import React from 'react';

// Elements
import MainBannerSection from "../elements/main-banner";
import AboutSection from "../elements/about";
import WorkSection from "../elements/work";
import NewTechnologySection from "../elements/new-technology";
//import AppointmentSection from "../elements/appointment";
import TestimonialSection from "../elements/testimonial";
import ServicesSliderSection from "../elements/services-slider";
import AwardsSection from "../elements/awards";
//import LatestNewsSection from "../elements/latest-news-slider";

function Index(){
	
	return(
		<>
			
			<MainBannerSection />
			
			<AboutSection />
			
			<WorkSection />

			<NewTechnologySection />
			{/* removing appointment section for now */}
			{/* <AppointmentSection /> */}
			
			<ServicesSliderSection />
			
			<AwardsSection />

			<TestimonialSection />
			
		
			
			
		</>
		// <LatestNewsSection />
	);
}

export default Index;